import { render } from "./AddRecipients.vue?vue&type=template&id=7b83e678&scoped=true"
import script from "./AddRecipients.vue?vue&type=script&lang=js"
export * from "./AddRecipients.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./AddRecipients.vue?vue&type=style&index=0&id=7b83e678&module=true&lang=css"
cssModules["$style"] = style0
import "./AddRecipients.vue?vue&type=style&index=1&id=7b83e678&scoped=true&lang=css"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-7b83e678"]])

export default __exports__